<template>
  <v-dialog
    :value="true"
    max-width="500"
    persistent
    @click:outside="closeModal()"
  >
    <div class="popup-decline-reason">
      <div class="popup-decline-reason-title">{{ titlePopup }}</div>
      <v-divider />
      <div class="popup-decline-reason-body">
        <textarea
          :placeholder="placeholderPopup"
          maxlength="255"
          v-model="contactChoose.comment"
        ></textarea>
      </div>
      <div class="popup-decline-reason-action">
        <v-btn
          color="#D9D9D9"
          @click="closeModal()"
          height="40px"
          style="color: black;text-transform: unset !important;"
          >Hủy</v-btn
        >
        <v-btn
          color="#D83410"
          style="margin-right: 27px !important;text-transform: unset !important;"
          height="40px"
          @click="confirmApproved()"
          >Xác nhận</v-btn
        >
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpenPopupApprove: {
      type: Boolean,
      default: true,
    },
    titlePopup: {
      default: () => "",
    },
    placeholderPopup: {
      default: () => "",
    },
    contactChoose: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      noteInput: this.textareaInput,
    };
  },
  created() {
    //
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    confirmApproved() {
      this.$emit("confirmApproved", this.contactChoose);
    },
  },
};
</script>

<style scoped lang="scss">
.popup-decline-reason {
  min-height: 297px;
  background: #ffffff;
  .popup-decline-reason-title {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    padding: 30px 0px 21px 22px;
  }
  .popup-decline-reason-body {
    textarea {
      min-height: 200px;
      width: 441px;
      border: 0.5px solid #000000;
      margin: 0px 22px 18px 31px !important;
      padding: 10px;
    }
  }
  .popup-decline-reason-action {
    display: flex;
    justify-content: end;
    padding-bottom: 15px;
  }
}
.table-contact {
  .transaction-status {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
  }
  .user-comment {
    -webkit-line-clamp: 3;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    max-width: 200px;
  }
}
</style>
